import React, {useState} from "react";
import {useTranslation} from "react-i18next";
// local
import {Modal} from "components/Modal";
import {Input} from "components/Input";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconTrashCan} from "components/icons";

export const CustomCheckpointModal = ({marking, loading, onSave, onRemove, onClose}) => {
  const [values, setValues] = useState(marking);
  const {t} = useTranslation();

  return (
    <Modal
      width={600}
      rounded
      noTitleHeader
      noCenterContent
      style={{marginTop: "20vh"}}
      onClose={onClose}
    >
      <div className="procurement-create-edit-modal__content">
        <div className="df-row-center">
          <span className="mr-2 wdth-100">
            {t("CUSTOM_CHECKPOINTS_MODAL_NAME_LABEL")}
          </span>
          <Input
            width={50}
            uppercaseText
            maxLength={2}
            defaultValue={values.name}
            onChange={(e) => setValues((prev) => ({...prev, name: e.target.value}))}
            placeholder="XX"
            addClass="pl-2"
          />
          <span className="ml-2 fz-12 __italic">
            {t("CUSTOM_CHECKPOINTS_MODAL_NAME_INFO")}
          </span>
        </div>
        <div className="df-row-center mt-4">
          <span className="mr-2" style={{minWidth: "100px"}}>
            {t("CUSTOM_CHECKPOINTS_MODAL_DESCRIPTION_LABEL")}
          </span>
          <Input
            fullWidth
            defaultValue={values.description}
            onChange={(e) =>
              setValues((prev) => ({...prev, description: e.target.value}))
            }
            placeholder={t("CUSTOM_CHECKPOINTS_MODAL_DESCRIPTION_PLACEHOLDER")}
            addClass="pl-2"
          />
        </div>
        <div className="df-row-jce-center mt-4">
          {!!marking.id && (
            <ButtonTransparent
              iconButton
              color="red"
              icon={<IconTrashCan />}
              onIconClick={() => onRemove(marking.id)}
            />
          )}
          <ButtonTransparent
            name="CANCEL"
            color="red"
            small
            onClick={onClose}
            disabled={loading}
            addClass="mla mr-2"
          />
          <ButtonTransparent
            loading={loading}
            disabled={!values.name || !values.description}
            nonTransparent
            small
            name="SAVE"
            onClick={() => onSave(values)}
          />
        </div>
      </div>
    </Modal>
  );
};
